import { render, staticRenderFns } from "./BmlrBrowse.vue?vue&type=template&id=4fdf9e7b"
import script from "./BmlrBrowse.vue?vue&type=script&lang=js"
export * from "./BmlrBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports